import styled, { css } from 'styled-components';
import {
  U21FormLabel,
  U21Divider,
  //   U21Spacer,
  U21Typography,
  U21HelpTooltip,
  //   U21Button,
} from 'app/shared/u21-ui/components';
import { HTMLProps, ReactNode } from 'react';
import { getDOMProps } from 'app/shared/utils/react';
// import { IconTrash } from '@u21/tabler-icons';
// import { SarDeleteButton } from 'app/modules/fincenSarNew/components/SarDeleteButton';

// Block 1
export const Block1 = ({
  action,
  children,
  hasDivider,
  title,
  hasMarginTop = true,
}: {
  action?: ReactNode;
  children: ReactNode;
  hasDivider?: boolean;
  title?: ReactNode;
  hasMarginTop?: boolean;
}) => {
  return (
    <StyledBlock1Div $hasMarginTop={hasMarginTop}>
      {hasDivider && <U21Divider style={{ marginBottom: '2rem' }} horizontal />}
      {title && (
        <Block1Header>
          <U21Typography variant="h4">{title}</U21Typography>
          {action}
        </Block1Header>
      )}
      {children}
    </StyledBlock1Div>
  );
};
interface StyledBlock1DivProps {
  $hasMarginTop: boolean;
}
const StyledBlock1Div = styled.div<StyledBlock1DivProps>`
  ${({ $hasMarginTop }) => {
    if ($hasMarginTop) {
      return css`
        margin-top: 3rem;
      `;
    }
    return css``;
  }}
`;
const Block1Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

// Block 2
interface Block2Props {
  $marginTop?: string;
}

export const Block2 = styled.div<Block2Props>`
  display: flex;
  align-items: start;
  gap: 1rem;
  ${({ $marginTop }) => {
    if ($marginTop) {
      return css`
        margin-top: ${$marginTop};
      `;
    }
    return css`
      margin-top: 2rem;
    `;
  }}
`;

export const Block2MainField = styled.div`
  flex: 1;
`;

export const Block2Secondary = styled.div`
  display: flex;
`;

export const Block2Heading = ({
  children,
  description,
  $marginTop = '0',
}: {
  children: ReactNode;
  description?: string;
  $marginTop?: string;
}) => {
  return (
    <div>
      <U21Typography style={{ marginTop: $marginTop }} variant="h6">
        {children}
      </U21Typography>
      {description && (
        <U21Typography color="text.secondary" variant="body2">
          {description}
        </U21Typography>
      )}
    </div>
  );
};

interface Block2AddActionsPropsDiv {
  $justifyContent?: string;
  $marginTop?: string;
}

export const Block2AddActionsDiv = styled.div<Block2AddActionsPropsDiv>`
  display: flex;
  ${({ $justifyContent }) => {
    if ($justifyContent) {
      return css`
        justify-content: ${$justifyContent};
      `;
    }
    return css`
      justify-content: end;
    `;
  }}
  ${({ $marginTop }) => {
    if ($marginTop) {
      return css`
        margin-top: ${$marginTop};
      `;
    }
    return css`
      margin-top: 2rem;
    `;
  }}
`;

// Labels
interface FieldLabelProps extends HTMLProps<HTMLLabelElement> {
  children: ReactNode;
  description?: string;
  required?: boolean;
  helpText?: ReactNode;
}

export const FieldLabel = ({
  children,
  description,
  required,
  helpText,
  ...rest
}: FieldLabelProps) => {
  return (
    <StyledLabelDiv>
      <StyledLabel required={required} {...getDOMProps(rest)}>
        {children}
      </StyledLabel>
      {helpText && <StyledU21HelpTooltip help={helpText} />}
      {description && (
        <U21Typography color="text.secondary" variant="body2">
          {description}
        </U21Typography>
      )}
    </StyledLabelDiv>
  );
};
const StyledLabelDiv = styled.div`
  width: 25%;
  margin-top: 8px;
`;
const StyledLabel = styled(U21FormLabel)`
  display: inline;
`;
export const StyledU21HelpTooltip = styled(U21HelpTooltip)`
  margin-top: -2px;
`;

export const InlineFieldLabel = styled(U21FormLabel)`
  display: inline;
  margin-top: 8px;
  margin-right: 0.5rem;
`;

export const ActionsContainer = ({
  children,
  $justifyContent,
  $width,
}: {
  children: ReactNode;
  $justifyContent?: string;
  $width?: string;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        width: $width || '6.5rem',
        justifyContent: $justifyContent || 'start',
        alignItems: 'center',
      }}
    >
      {children}
    </div>
  );
};
